
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 2c-4.97 0-9 4.031-9 9a9 9 0 009 9 9 9 0 009-9c0-4.969-4.03-9-9-9zm0 3.992a1.524 1.524 0 110 3.048 1.524 1.524 0 010-3.048zm2.032 9.218c0 .24-.195.435-.435.435H9.403a.436.436 0 01-.435-.435v-.871c0-.24.195-.436.435-.436h.436v-2.322h-.436a.436.436 0 01-.435-.436v-.87c0-.241.195-.436.435-.436h2.323c.24 0 .435.195.435.435v3.63h.436c.24 0 .435.194.435.435v.87z","fill":"#282498","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_info_circle.svg